/**
 * Tema claro/oscuro (2026-07-17).
 *
 * La clínica usa el tema CLARO por defecto; el oscuro solo se aplica si el
 * usuario lo elige. La preferencia se guarda en localStorage y se aplica
 * añadiendo/quitando la clase `dark` en <html> (Tailwind darkMode: 'class').
 * El primer aplicado ocurre en un script inline de index.html (sin parpadeo).
 */
const KEY = 'cjo-theme';

export function getTheme() {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
  } catch (e) {
    return 'light';
  }
}

export function applyTheme(theme) {
  const dark = theme === 'dark';
  document.documentElement.classList.toggle('dark', dark);
  try {
    localStorage.setItem(KEY, dark ? 'dark' : 'light');
  } catch (e) {
    /* noop */
  }
  return dark ? 'dark' : 'light';
}

export function toggleTheme() {
  return applyTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

/**
 * Páginas del paciente (tablet de recepción y enlaces que abre él desde casa).
 * Van SIEMPRE en claro: se firman con el dedo sobre un lienzo blanco y con el
 * tema oscuro heredado del navegador el trazo no se veía (2026-07-26). La
 * preferencia guardada no se toca — es solo para lo que ve el paciente.
 *
 * Cada ruta vale ella sola o seguida de «/…» (23/9/2026). La lista tenía
 * `/salud/` y `/mis-pasos/` CON barra, así que `/salud` y `/mis-pasos` sin
 * barra —el enlace cortado al copiarlo, que enseña «enlace incompleto»—
 * salían en oscuro. Y no vale «empieza por /salud» a secas: `/salud-enlaces`
 * es una pantalla del personal. La misma lista en public/theme.js.
 */
// `/tablet` (29/9/2026): el selector de modo del iPad, que va con los quioscos.
export const RUTAS_PUBLICAS = ['/firma-lopd', '/salud', '/confirmar-cita', '/firma-consent', '/firma-consent-link', '/mis-pasos', '/tablet'];

export function esRutaPublica(path) {
  const p = path || (typeof window !== 'undefined' ? window.location.pathname : '');
  return RUTAS_PUBLICAS.some((r) => p === r || p.startsWith(`${r}/`));
}
